import { memo, useContext, createContext } from 'react';
import { DEFAULT_SCRUBBING } from './utils.js';
import { jsx } from 'react/jsx-runtime';
import '@dtvgo/classnames';

/* External */
var SeekableStartContext = /*#__PURE__*/createContext(0);
var SeekableEndContext = /*#__PURE__*/createContext(0);
var MouseOverProgressContext = /*#__PURE__*/createContext(null);
var SeekingValueContext = /*#__PURE__*/createContext(null);
var ScrubbingContext = /*#__PURE__*/createContext({});
var ActionsContext = /*#__PURE__*/createContext({});
function ProgressBarProviderComponent(_ref) {
  var _ref$seekable = _ref.seekable,
    seekable = _ref$seekable === void 0 ? null : _ref$seekable,
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? 0 : _ref$duration,
    _ref$mouseOverProgres = _ref.mouseOverProgress,
    mouseOverProgress = _ref$mouseOverProgres === void 0 ? null : _ref$mouseOverProgres,
    _ref$seekingValue = _ref.seekingValue,
    seekingValue = _ref$seekingValue === void 0 ? null : _ref$seekingValue,
    _ref$scrubbing = _ref.scrubbing,
    scrubbing = _ref$scrubbing === void 0 ? null : _ref$scrubbing,
    actions = _ref.actions,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children;
  return /*#__PURE__*/jsx(ActionsContext.Provider, {
    value: actions,
    children: /*#__PURE__*/jsx(ScrubbingContext.Provider, {
      value: scrubbing || DEFAULT_SCRUBBING,
      children: /*#__PURE__*/jsx(SeekingValueContext.Provider, {
        value: seekingValue,
        children: /*#__PURE__*/jsx(MouseOverProgressContext.Provider, {
          value: mouseOverProgress,
          children: /*#__PURE__*/jsx(SeekableStartContext.Provider, {
            value: (seekable === null || seekable === void 0 ? void 0 : seekable.start) || 0,
            children: /*#__PURE__*/jsx(SeekableEndContext.Provider, {
              value: (seekable === null || seekable === void 0 ? void 0 : seekable.end) || duration,
              children: children
            })
          })
        })
      })
    })
  });
}
var ProgressBarProvider = /*#__PURE__*/memo(ProgressBarProviderComponent);
function useSeekableStart() {
  return useContext(SeekableStartContext);
}
function useSeekableEnd() {
  return useContext(SeekableEndContext);
}
function useMouseOverProgress() {
  return useContext(MouseOverProgressContext);
}
function useSeekingValue() {
  return useContext(SeekingValueContext);
}
function useScrubbing() {
  return useContext(ScrubbingContext);
}
function useActions() {
  return useContext(ActionsContext);
}

export { ProgressBarProvider, useActions, useMouseOverProgress, useScrubbing, useSeekableEnd, useSeekableStart, useSeekingValue };
//# sourceMappingURL=ProgressBarContext.js.map
